<template>
  <div class="column has-text-left">
    <h1 class="title is-4">Kursdeltagare</h1>
    <div class="buttons">
      <a class="button is-primary" @click="copyMail"> Kopiera mailadresser </a>
      <a class="button is-primary" @click="downloadCSV">
        Ladda ner deltagarelista</a
      >
    </div>
    <br />
    <table class="table">
      <thead>
        <tr>
          <th>Namn</th>
          <th v-if="!extendedFields">Telefon</th>
          <th v-if="extendedFields">Förälder telefon</th>
          <th>Mailadress</th>
          <th v-if="extendedFields">Annat</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="booking in bookings" :key="booking.id">
          <td>
            <router-link :to="'/customers?id=' + booking.customer._id"
              >{{ booking.customer.first_name }}
              {{ booking.customer.last_name }}</router-link
            >
          </td>
          <td v-if="!extendedFields">
            {{ booking.customer.phone_number }}
          </td>
          <td v-if="extendedFields">
            {{ booking.customer.parent_phone_first }} &
            {{ booking.customer.parent_phone_second }}
          </td>
          <td>
            <a :href="'mailto:{$booking.customer.email}'">{{
              booking.customer.email
            }}</a>
          </td>
          <td v-if="extendedFields">{{ booking.customer.other }}</td>
        </tr>
      </tbody>
    </table>
    <input type="text" id="copyMail" :value="getMails()" />
  </div>
</template>

<script>
import axios from "@/utils/request.js";

export default {
  name: "CourseCustomers",
  props: {
    course: Object,
  },
  data: function () {
    return {
      bookings: [],
      instructors: [],
      extendedFields: false,
    };
  },
  methods: {
    fetchCustomers() {
      axios
        .get("/api/courses/" + this.course._id + "/bookings")
        .then((response) => {
          this.bookings = response.data;
        });
    },
    getExtendedFields: function () {
      axios.get("/api/settings/extendedfields").then((response) => {
        this.extendedFields = response.data;
      });
    },
    getMails() {
      let mail = [
        ...new Set(this.bookings.map((booking) => booking.customer.email)),
      ].toString();
      return mail.replace(/,/g, "; ");
    },
    copyMail() {
      let copyText = document.getElementById("copyMail");
      copyText.select();

      document.execCommand("copy");
    },
    downloadCSV() {
      axios
        .get("/api/courses/" + this.course._id + "/bookings/csv", {
          responseType: "blob",
        })
        .then((response) => {
          console.log("CSV");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "export.csv");
          document.body.appendChild(link);
          link.click();
        });
    },
  },
  created() {
    this.fetchCustomers();
    this.getExtendedFields();
  },
  watch: {
    course: function () {
      this.fetchCustomers();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#copyMail {
  position: absolute;
  top: -200px;
}
</style>